<script setup lang="ts">
import { Head, useForm } from '@inertiajs/vue3';

const form = useForm({
    email: '',
    password: '',
});

const submit = () => {
    form.post('/login', {
        onFinish: () => form.reset('password'),
    });
};
</script>

<template>
    <Head title="Login" />
    <div class="min-h-screen bg-linear-(--gradient-primary) flex items-center justify-center px-4">
        <div class="w-full max-w-md">
            <div class="rounded-2xl border border-white/50 bg-white/80 p-8 shadow-2xl backdrop-blur">
                <div class="mb-8 text-center space-y-2">
                    <h1 class="text-2xl font-semibold">Witaj w Omniscient!</h1>
                    <p class="text-sm">Zaloguj się przy użyciu swojego adresu email!</p>
                </div>

                <form class="space-y-6" @submit.prevent="submit">
                    <div>
                        <label class="mb-2 block text-sm font-medium " for="email">Email</label>
                        <input
                            id="email"
                            v-model="form.email"
                            type="email"
                            required
                            autocomplete="email"
                            class="w-full rounded-lg border border-white/20 bg-transparent px-4 py-2.5 placeholder:text-black/40 focus:border-white focus:outline-none focus:ring-2 focus:ring-white/30"
                            placeholder="admin@admin"
                        />
                        <p v-if="form.errors.email" class="mt-2 text-sm text-red-400">{{ form.errors.email }}</p>
                    </div>

                    <div>
                        <label class="mb-2 block text-sm font-medium text-black/80" for="password">Password</label>
                        <input
                            id="password"
                            v-model="form.password"
                            type="password"
                            required
                            autocomplete="current-password"
                            class="w-full rounded-lg border border-white/20 bg-transparent px-4 py-2.5 text-black placeholder:text-black/40 focus:border-white focus:outline-none focus:ring-2 focus:ring-white/30"
                            placeholder="admin"
                        />
                        <p v-if="form.errors.password" class="mt-2 text-sm text-red-400">{{ form.errors.password }}</p>
                    </div>

                    <button
                        class="inline-flex w-full items-center justify-center rounded-lg bg-white/90 px-4 py-2.5 text-sm font-semibold text-slate-900 transition hover:bg-white disabled:opacity-50"
                        type="submit"
                        :disabled="form.processing"
                    >
                        {{ form.processing ? 'Logowanie...' : 'Zaloguj' }}
                    </button>
                </form>
            </div>
        </div>
    </div>
</template>
